import { render, staticRenderFns } from "./navbuttons-compact.vue?vue&type=template&id=30a48df2&"
import script from "./navbuttons-compact.vue?vue&type=script&lang=js&"
export * from "./navbuttons-compact.vue?vue&type=script&lang=js&"
import style0 from "./navbuttons-compact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a48df2')) {
      api.createRecord('30a48df2', component.options)
    } else {
      api.reload('30a48df2', component.options)
    }
    module.hot.accept("./navbuttons-compact.vue?vue&type=template&id=30a48df2&", function () {
      api.rerender('30a48df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/nav/navbuttons-compact.vue"
export default component.exports